<ng-container *ngIf="initialized">
  <div class="chat-button-wrapper">
    <button type="button" (click)="collapseChat()" class="collapse-chat-btn btn btn-sm btn-icon btn-secondary rounded-circle transition-3d-hover mb-1">
      <span class="fa fa-caret-down"></span>
    </button>
  </div>
  <div #messageContainer (scroll)="onScroll($event)" class="live-messages">
    <ul>
      <li *ngFor="let message of exisitingMessages" class="mb-3" [ngClass]="{ replies: user.id != message.user.id, sent: user.id == message.user.id }">
        <img class="avatar u-sm-avatar rounded-circle" [fallback]="'fetch-avatar?userId=' + message.user.id" src="https://bxlimages.blob.core.windows.net/avatar-cache/{{ message.user.id }}-avatar.png"   />
        <span *ngIf="user.id != message.user.id">{{ message.user.firstName + ' ' + message.user.lastName }}</span>
        <p class="message-content" innerHTML="{{ message.message }}"></p>
      </li>
      <li *ngFor="let message of messages" class="mb-3" [ngClass]="{ replies: user.id != message.userId, sent: user.id == message.userId, 'system-message': message.systemMessage }">
        <img class="avatar u-sm-avatar rounded-circle" [fallback]="'fetch-avatar?userId=' + message.userId" src="https://bxlimages.blob.core.windows.net/avatar-cache/{{ message.userId }}-avatar.png"  /><span *ngIf="user.id != message.userId">{{ message.name }}</span>
        <p class="message-content" innerHTML="{{ message.message }}"></p>
      </li>
      <li style="line-height: 0">&nbsp;</li>
    </ul>
    <p *ngIf="messages.length + exisitingMessages.length == 0" class="no-chats">Say hello.</p>
  </div>
  <div class="bxl-emoji-picker" [style.visibility]="toggled ? 'visible' : 'hidden'">
    <div class="btn-group" role="group" aria-label="First group">
      <button type="button" (click)="handleSelection('😀')" class="btn btn-lg xs-no-padding btn-white">😀</button>
      <button type="button" (click)="handleSelection('😂')" class="btn btn-lg xs-no-padding btn-white">😂</button>
      <button type="button" (click)="handleSelection('😲')" class="btn btn-lg xs-no-padding btn-white">😲</button>
      <button type="button" (click)="handleSelection('😞')" class="btn btn-lg xs-no-padding btn-white">😞</button>
      <button type="button" (click)="handleSelection('👍')" class="btn btn-lg xs-no-padding btn-white">👍</button>
      <button type="button" (click)="handleSelection('👎')" class="btn btn-lg xs-no-padding btn-white">👎</button>
      <button type="button" (click)="handleSelection('❤️')" class="btn btn-lg xs-no-padding btn-white">❤️</button>
      <button type="button" (click)="handleSelection('❗️')" class="btn btn-lg xs-no-padding btn-white">❗️</button>
      <button type="button" (click)="handleSelection('❓')" class="btn btn-lg xs-no-padding btn-white">❓</button>
    </div>
  </div>
  <div class="input-group">
    <input #chatbox type="text" class="form-control" [(ngModel)]="chatMessage" (keyup.enter)="sendMessage()" placeholder="Type a message..." aria-label="" aria-describedby="button-addon2" />
    <div class="input-group-append">
      <button class="btn btn-white" (click)="toggled = !toggled" type="button" id="button-addon2">😄</button>
    </div>
  </div>
</ng-container>
